// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"2c2363a7","787":"0a4a62f2"}[chunkId] + ".chunk.js";
};